export interface DealerDriverDto {
  dealer: {
    id: string;
  };
  name: string;
  enabled: boolean;
  status: string;
  id: string;
  createdAt: string;
  modifiedAt: string;
}

export function isOnlineDriverStatus(status?: string): boolean {
  return (status ?? "").trim().toLowerCase() === "online";
}

export interface DealerDriversResponse {
  data: DealerDriverDto[];
  pagination: {
    limit: number;
    offset: number;
    keyset: string;
    count: number;
    totalCount: number;
  };
}
